/**
 * 返回recaptcha的网路地址
 * @returns {url} string
 */
export const getRecaptchaJsUri = () => {
    let url = '';



    return url;
};

let isLoaded = false;
export const setRecaptchaJsLoaded = (loaded: boolean) => {
    isLoaded = loaded;
};

export const getRecaptchaJsLoaded = () => {
    return isLoaded;
};
